import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAccessToken } from '../useProfile';

export type DisconnectableIntegration = 'strava' | 'garmin';

type UseDisconnectIntegrationOptions = {
  onError?: (error: Error, integration: DisconnectableIntegration) => void;
};

export const useDisconnectIntegration = ({
  onError,
}: UseDisconnectIntegrationOptions = {}) => {
  const { data: accessToken } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (integration: DisconnectableIntegration) => {
      const displayName = integration === 'strava' ? 'Strava' : 'Garmin';
      const response = await fetch(
        `${import.meta.env.REACT_APP_API_SERVICE_URI}/api/profile/integrations/${integration}`,
        {
          method: 'DELETE',
          headers: { Authorization: `Bearer ${accessToken}` },
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to disconnect ${displayName}`);
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['profile'] });
    },
    onError,
  });
};
